import * as React from 'react';
import {AirbnbSelectDesktopMenu} from './SelectDesktopMenu';
import {type SelectValue} from './types';
import {type SelectOption} from '../../lib/selector-option';
import {cn} from '../../lib/cn';
import type {ReactNode} from 'react';

type AirbnbSelectDesktopContentProps<
  T,
  V extends SelectValue,
  L extends string | number | ReactNode,
> = {
  isOpen: boolean;
  listboxId: string;
  labelId: string;
  errorId?: string;
  options: SelectOption<T, V, L>[];
  value?: SelectOption<T, V, L> | null;
  highlightedIndex: number;
  onOptionClick: (option: SelectOption<T, V, L>) => void;
  onOptionHover: (index: number) => void;
  onKeyDown: React.KeyboardEventHandler<HTMLDivElement>;
  disabled?: boolean;
  menuClassName?: string;
  dropdownClassName?: string;
  listRef: React.RefObject<HTMLDivElement>;
  setOptionRef: (index: number, node: HTMLButtonElement | null) => void;
  getOptionId: (index: number) => string;
  noOptionsMessage?: () => string | undefined;
};

function AirbnbSelectDesktopContent<
  T,
  V extends SelectValue,
  L extends string | number | ReactNode,
>({
  isOpen,
  listboxId,
  labelId,
  errorId,
  options,
  value,
  highlightedIndex,
  onOptionClick,
  onOptionHover,
  onKeyDown,
  disabled,
  menuClassName,
  dropdownClassName,
  listRef,
  setOptionRef,
  getOptionId,
  noOptionsMessage,
}: AirbnbSelectDesktopContentProps<T, V, L>) {
  if (!isOpen) return null;

  return (
    <div
      className={cn(
        'absolute left-0 right-0 top-[calc(100%+8px)] z-20 overflow-hidden rounded-[20px] border border-[var(--chekin-airbnb-border)] bg-white shadow-[0_14px_30px_rgba(18,18,18,0.08)]',
        dropdownClassName,
      )}
    >
      <AirbnbSelectDesktopMenu
        id={listboxId}
        options={options}
        labelledBy={labelId}
        describedBy={errorId}
        selectedValue={value}
        highlightedIndex={highlightedIndex}
        onOptionClick={onOptionClick}
        onOptionHover={onOptionHover}
        onKeyDown={onKeyDown}
        disabled={disabled}
        menuClassName={menuClassName}
        listRef={listRef}
        selectedOptionRef={setOptionRef}
        getOptionId={getOptionId}
        noOptionsMessage={noOptionsMessage}
      />
    </div>
  );
}

export {AirbnbSelectDesktopContent};
